import React, { Fragment } from "react";
// Material UI imports
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckIcon from "@material-ui/icons/Check";
import { makeStyles, createStyles } from "@material-ui/core/styles";
// Other relative imports
import { IFilesStore } from "../../stores/FilesStore";
import { ReqStatus } from "../../types/ReqStatus";

const useStyles = makeStyles(() =>
  createStyles({
    list: {
      height: "300px",
      overflow: "auto",
    },
  })
);

export interface IBehaviorsListProps {
  filesStore: IFilesStore;
  selected: string | null;
  onChange?: (value: string) => void;
}

export const BehaviorsList = ({
  selected,
  filesStore,
  onChange,
}: IBehaviorsListProps) => {
  const classes = useStyles();

  if (filesStore.reqStatus === ReqStatus.Loading) {
    return <CircularProgress />;
  }

  if (filesStore.reqStatus === ReqStatus.Failed) {
    return (
      <Typography>
        Unable to load profile files list. Please try again later.
      </Typography>
    );
  }

  if (filesStore.reqStatus === ReqStatus.Succeeded) {
    return (
      <List className={classes.list}>
        {filesStore.profileFiles.map((profileFile, i) => {
          const isSelected = profileFile.file === selected;
          return (
            <Fragment key={profileFile.file}>
              <ListItem
                selected={isSelected}
                divider={i < filesStore.audioFiles.length - 1}
                onClick={() => onChange?.(profileFile.file)}
                button
              >
                {isSelected && (
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                )}
                <ListItemText
                  inset={!isSelected}
                  primary={
                    <Typography variant="body2">
                      {profileFile.description}
                    </Typography>
                  }
                />
              </ListItem>
            </Fragment>
          );
        })}
      </List>
    );
  }

  return null;
};
